/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
    var onePlay = 0;


    function removeIntro() {
      $('.preloader').addClass('is-removed');
      $('.top__logo').addClass('is-visible');
    }

    $(window).scroll(function(){

      var height = $(window).scrollTop();
      if(height  > 1) {
        removeIntro();
      }
    });

    $('#scrollCollection, .preloader__logo').click(function(event) {
      removeIntro();
    });

    // Hack

    $('.dropdown-menu li').click(function(event) {
      event.stopPropagation();
    });

    // Animations preloader

    // Menu

    var menuIcon = $('.burger-open');
    var menuText = $('.burger__text');
    var menuPane = $('.menu');
    var menuOpen = $('.menu--expanded');
    var page = $('.content-wrap');
    var topBar = $('.top');
    var scrollText = $('.preloader__scroll');


    menuIcon.click(function(e){
      e.preventDefault();

      // Open
      menuPane.toggleClass('menu--expanded');
      $('.burger').addClass('burger--open');
      topBar.toggleClass('top--open');
      page.toggleClass('content-wrap--open');

      $(this).toggleClass('open');
      setTimeout(function(){
        openSubmenu();
      }, 0);

    });

    $('.page-content, .content-wrap, .li-demarche, .li-contact, .li-savoir-faire').click(function(event) {
      if (menuPane.hasClass('menu--expanded')) {
        menuIcon.toggleClass('open');
        menuPane.toggleClass('menu--expanded');
        topBar.toggleClass('top--open');
        page.toggleClass('content-wrap--open');
      }
    });
    // Sub menu

    var subMenuTitles = $('.menu-item-type-taxonomy'); //dropdown-toggle
    var subMenuTitlesLinks = $('.menu-item-type-post_type');
    var subMenuContent = $('.sub-menu');


    subMenuTitles.click(function(event) {
      if ($(this).hasClass('category-active')) {
        $(this).removeClass('category-active');
      } else {
        $(this).addClass('category-active');
      }
    });

    //$('.dropdown-menu li').click(function(event) {
    //  event.preventDefault();
    //  return false;
    //});

    function openSubmenu(){
      var currentMenuParent = $('#bs-example-navbar-collapse-1')
        .find('.current-menu-item')
        .closest('.current-menu-parent')
        .find('a:first')
        .trigger('click');
    }

    $('.menu-item').click(function(event) {
      if (!($(this).hasClass('menu-item-has-children'))) {
        //event.preventDefault();
        navigate($(this).find('a').prop('href'));
        menuIcon.trigger('click');
      }
    });

    // Navigation

    $('.menu-item-type-custom, #button-from-top').click(function(event) {
      addPix = 0;
      //flagSkroller = 0;
      navigate($(this).find('a').prop('href'));
    });

    $(window).scroll(function(){
      if($(window).scrollTop() > 100) {
        $('.scrollTop').show();
      } else {
        $('.scrollTop').hide();
      }
    });

    $('.scrollTop').on('click', function(event) {
      event.preventDefault();
      //navigate($(this).find('a').prop('href'));
      $('html, body').animate({
         scrollTop: $('html, body').offset().top
      }, 1000);
    });


    // Update section viewed

    $('.li-demarche, .li-savoir-faire').addClass('menu-item-home');

    if ($('.page-content').hasClass('landing-menu')) {

      $('.menu__links').find('li').removeClass('active-menu-item-home');
      $('.li-demarche').addClass('active-menu-item-home');

      $(window).scroll(function() {
         if ($(window).scrollTop() <= $('#demarche').height() + $('#collections').height() - 120) {
           $('.menu__links').find('li').removeClass('active-menu-item-home');
           $('.li-demarche').addClass('active-menu-item-home');
         } else if ($(window).scrollTop() >= $('#savoir-faire').position().top - 500) {
           $('.menu__links').find('li').removeClass('active-menu-item-home');
           $('.li-savoir-faire').addClass('active-menu-item-home');
         } else {
           $('.menu__links').find('li').removeClass('active-menu-item-home');
           $('.li-demarche').addClass('active-menu-item-home');
         }
      });
    }

    // $('#savoir-faire').offset().top -100

    if ($(window).width() < 992 ) {

      // Close menu after click on intern anchor
      $('.menu-item-type-custom').click(function(event) {
        navigate($(this).find('a').prop('href'));
        menuIcon.trigger('click');
      });
    }


    // Carousel

    $('.pproduct__images--thumbs ul li').on('click', function(){
        $(this).siblings().removeClass('active-thumb');
        $(this).addClass('active-thumb');
    });

    $('#carousel').hammer().on('swipeleft', function(){
      $(this).carousel('next');
    })
    $('#carousel').hammer().on('swiperight', function(){
      $(this).carousel('prev');
    })
    // Accordeon

    $('#accordion')
      .on('show.bs.collapse', function(e) {
        $(e.target).prev('.panel-heading').children('h4').toggleClass('panel-title').addClass('accordion--open');
      })
      .on('hide.bs.collapse', function(e) {
        $(e.target).prev('.panel-heading').children('h4').toggleClass('panel-title').removeClass('accordion--open');
      });

    var fullHeight = $('.full-height');

    function windowHeight() {
      var winHeight = $(window).height();
      fullHeight.css('height', winHeight);
    }

    windowHeight();

    $(window).resize(function() {
      windowHeight();
    });

    // Form change color when input is filled
    $('input:not(:submit), textarea').on('blur', function () {
      if ($(this).val()) {
        $(this).css({
          'color': '#69686e',
          'background-color': '#fff'
        });
      }
      else {
        $(this).css({
          'color': '#bebebe',
          'background-color': '#f2f2f2'
        });
      }
    });

    // Form change color when input is filled
    $('input:not(:submit), textarea').focus(function(event) {
      $(this).css({
        'color': '#69686e',
        'background-color': '#fff',
        'border': '1px solid #c5a76b'
      }).focusout(function(event) {
        if ($(this).hasClass('requiredfield') && (!$(this).val())) {
          $(this).css('border', '1px solid red');
        } else {
          $(this).css('border', '1px solid #bebebe');
        }
      });
    });

    // Shop page
    $('.owl-carousel').owlCarousel({
        loop:false,
        margin:20,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    })
    var spins = document.getElementsByClassName("spin");
    for (var i = 0, len = spins.length; i < len; i++) {
        var spin = spins[i],
            span = spin.getElementsByTagName("span"),
            input = spin.getElementsByTagName("input")[0];

        input.onchange = function() { input.value = +input.value || 0; };
        span[0].onclick = function() { input.value = Math.max(0, input.value - 1); };
        span[1].onclick = function() { input.value -= -1; };
    }
        // Select or die
        $('select').selectOrDie({
          onChange: function() {
            var $this = $(this);
          },
          size: 6
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

// Inside your app.js paste this
// First we trigger the form submit event
jQuery( document ).ready( function () {
  jQuery('.wpcf7-submit').click(function () {
          // We remove the error to avoid duplicate errors
    jQuery('.error').remove();

          // We create a variable to store our error message
    var errorMsg = jQuery('<span class="error">Your emails do not match.</span>');

          // Then we check our values to see if they match
          // If they do not match we display the error and we do not allow form to submit
    if (jQuery('.email').find('input').val() !== jQuery('.email-confirm').find('input').val()) {
      errorMsg.insertAfter(jQuery('.email-confirm').find('input'));

      return false;
    } else {
                  // If they do match we remove the error and we submit the form
      jQuery('.error').remove();

      return true;
    }
  });
} );
